"use client";
import { BorderedButton } from "@/components/button/borderedButton";
import { ConfirmButton } from "@/components/button/confirmButton";
import { RegularModal } from "@/components/modals/modals";
import { useTranslations } from "next-intl";
import { useId } from "react";

interface IReplaceGiftCardModal {
  isOpen: boolean;
  onRequestClose: () => void;
  merchantColor: string;
  replaceGiftCard: () => void;
}

export const ReplaceGiftCardModal = ({
  isOpen,
  onRequestClose,
  merchantColor,
  replaceGiftCard,
}: IReplaceGiftCardModal) => {
  const t = useTranslations("ReplaceGiftCardModal");
  const titleId = useId();
  const subtitleId = useId();
  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="p-4"
      overlayClassName="bg-opacity-75"
      aria={{ labelledby: titleId, describedby: subtitleId }}
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-auto sm:w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto overflow-hidden">
        <h2
          id={titleId}
          aria-describedby={subtitleId}
          className="pt-6 px-6 text-2xl font-medium text-[#373737]"
        >
          {t("title")}
        </h2>
        <div className="py-4 px-6">
          <p
            id={subtitleId}
            className="mb-4 text-[15px] text-md text-[#000000]"
          >
            {t("message")}
          </p>
        </div>
        <div className="flex justify-end pt-0 pb-4 px-4 h-18 items-center gap-4">
          <div>
            <BorderedButton
              style={{
                color: merchantColor,
                borderColor: merchantColor,
              }}
              className="w-auto"
              onClick={replaceGiftCard}
            >
              {t("replaceButton")}
            </BorderedButton>
          </div>

          <ConfirmButton
            onClick={onRequestClose}
            className="w-auto h-full text-white disabled:text-black py-2 rounded disabled:bg-[#E5E5E5]"
          >
            {t("goBackButton")}
          </ConfirmButton>
        </div>
      </div>
    </RegularModal>
  );
};
